import { Component, OnInit } from '@angular/core';
import { Http, Response, Headers } from '@angular/http';
import { TranslateService } from '@ngx-translate/core';
import { environment } from './../environments/environment';

declare var window: any;
declare var ga: any;
declare var gtag: any;
 @Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
    title = 'app';
    api = 'http://127.0.0.1:4081/';
    data: any = null;
    public screenWidth = window.innerWidth;
    public onlineFlag = navigator.onLine;
    constructor(private translateService: TranslateService) { 
      if(environment.production){
        window.ga = window.ga || function() {
          (ga.q = ga.q || []).push(arguments)
        };
        ga.l = +new Date;
        ga('create', 'UA-127750011-1', 'auto');
        ga('require', 'eventTracker');
        ga('require', 'impressionTracker');
        ga('require', 'outboundLinkTracker');
        ga('require', 'urlChangeTracker');
        ga('require', 'pageVisibilityTracker');
        ga('require', 'maxScrollTracker');
        ga('send', 'pageview');
        // gtag('set', {'user_id': 'someUser'}); 
        // ga('set', 'userId', 'someUser');
      }
    }

   ngOnInit() {
    //  this.translateService.setDefaultLang('english');
    }

}

